
import { Mail } from "lucide-react";

interface EmailConfirmationProps {
  isDonation?: boolean;
}

export const EmailConfirmation = ({ isDonation = false }: EmailConfirmationProps) => {
  return (
    <div className="p-4 bg-green-50 rounded-lg text-center">
      <div className="flex justify-center mb-4">
        <div className="rounded-full bg-green-100 p-3">
          <Mail className="h-6 w-6 text-green-600" />
        </div>
      </div>
      <h3 className="text-lg font-semibold mb-2">Email de vérification envoyé !</h3>
      <p className="text-gray-600 mb-4">
        Veuillez vérifier votre boîte de réception et cliquer sur le lien pour confirmer votre {isDonation ? "don" : "signature"}.
      </p>
      <p className="text-sm text-gray-500 mb-3">
        Si vous ne recevez pas l'email dans les prochaines minutes, vérifiez votre dossier de spam.
      </p>
    </div>
  );
};
